/**
 * FeedbackBanner component displays success or error messages.
 * Used in ImportForm to show operation results.
 *
 * @param {Object} props - Component props
 * @param {Object} props.state - Banner state
 * @param {boolean} props.state.visible - Whether banner is visible
 * @param {string} props.state.variant - Banner variant ('success' or 'error')
 * @param {string} props.state.message - Message to display
 * @param {Function} props.onClose - Callback to close banner
 * @returns {React.ReactElement|null} Feedback banner or null if not visible
 */
export default function FeedbackBanner({ state, onClose }) {
  // Guard: Don't render if not visible
  if (!state.visible) {
    return null
  }

  const role = state.variant === 'error' ? 'alert' : 'status'

  return (
    <div
      className={`feedback-banner feedback-banner--${state.variant}`}
      role={role}
    >
      <p className="feedback-banner__message">{state.message}</p>
      <button
        type="button"
        className="feedback-banner__close"
        onClick={onClose}
        aria-label="Zamknij powiadomienie"
      >
        ×
      </button>
    </div>
  )
}
